import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickLinkComponent } from 'ZalamoLibrary/src/lib/ui/quick-link/quick-link.component';
import { RouterModule } from '@angular/router';
import { LanguageModule } from 'ZalamoLibrary/src/lib/zalamo/language/language.module';
import { QuickLinkForRouterPipe } from 'ZalamoLibrary/src/lib/ui/quick-link/quick-link-for-router.pipe';

@NgModule({
  declarations: [QuickLinkComponent, QuickLinkForRouterPipe],
  exports: [QuickLinkComponent, QuickLinkForRouterPipe],
  imports: [CommonModule, RouterModule, LanguageModule],
})
export class QuickLinkModule {}
